import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { getCLS, getFID, getLCP, getFCP, getTTFB } from "web-vitals";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { initAnalytics, trackEvent } from "./lib/analytics";
import "react-quill/dist/quill.snow.css";
import "./dist/styles.css";
import "./styles/main.css";

initAnalytics();

function sendToAnalytics({ name, delta, id }) {
  trackEvent(name, {
    value: Math.round(name === "CLS" ? delta * 1000 : delta),
    metric_id: id,
    metric_value: delta,
    metric_delta: delta,
  });
}

function reportWebVitals() {
  try {
    getCLS(sendToAnalytics);
    getFID(sendToAnalytics);
    getLCP(sendToAnalytics);
    getFCP(sendToAnalytics);
    getTTFB(sendToAnalytics);
  } catch {
    // Ignore web-vitals failures — never block the app.
  }
}

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

const container = document.getElementById("root");

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

if (process.env.NODE_ENV === "production") {
  reportWebVitals();
}
